import React from 'react';
import useAlert, { DefaultAlertReturnType } from '../../utils/useAlert';

const withAlerts = (Component: any) => (props: any) => {
  const alertHookProps: DefaultAlertReturnType = useAlert();
  return <Component {...props} {...alertHookProps} />;
};

export default withAlerts;
